
let options = {
    containerSelector: '#menu-w',
    scrollContainer: '#menu-in',
    toggleClass: "open",
    actionClass: "ready",
    childrenClass: "menu-item__subnav",
    backClass: 'back',
    backText: 'Retour au menu',
    globalToggleClass: 'menu-open',
    globalToggleAlreadyClass: 'menu-stay-open',
    mobileMenuSelector:'[js-mobile-menu-toggler]',
    subMenuOpenClass:'sub-open',
    closeSelector: '[js-menu-close]'
};

const setEventClick = (item, dest) => {

    item.addEventListener('click', (e) => {

        dest.classList.add(options.actionClass);

        let menu = document.querySelector(options.containerSelector);
        let body = document.querySelector('body');

        e.preventDefault();
        if (dest.classList.contains(options.toggleClass)) {

            setTimeout(() =>{
                dest.classList.remove(options.toggleClass);
                menu.classList.remove(options.subMenuOpenClass);
                setTimeout(() =>{  dest.classList.remove(options.actionClass); }, 200);
            }, 50);

            body.classList.remove(options.globalToggleClass);
            body.classList.remove(options.globalToggleAlreadyClass);
            return;
        }


        let container = document.querySelector(options.containerSelector);

        //wp default navigation
        let opens = container.querySelectorAll(`.menu-item-has-children.${options.toggleClass}`);
        for(let i = 0; i < opens.length; i++) {
            opens[i].classList.remove(options.toggleClass);
        }

        //dest.classList.add(options.toggleClass);
        //quick & dirty fix, sorry
        if(window.innerWidth < 960) {
            setTimeout(() => {
                dest.classList.add(options.toggleClass);
                menu.classList.add(options.subMenuOpenClass);

                let scrollContainer = document.querySelector(options.scrollContainer);
                scrollContainer.scrollTop = 0;

                setTimeout(() => {
                    dest.classList.remove(options.actionClass);
                }, 200);
            }, 50)
        }
        else{
            dest.classList.add(options.toggleClass);
            menu.classList.add(options.subMenuOpenClass);

            let scrollContainer = document.querySelector(options.scrollContainer);
            scrollContainer.scrollTop = 0;

            setTimeout(() => {
                dest.classList.remove(options.actionClass);
            }, 200);
        }

        if(!$(dest).parents('#topbar').length) {



            //if(body.classList.contains(options.globalToggleClass) && !body.classList.contains(options.globalToggleAlreadyClass))
            {
                body.classList.add(options.globalToggleAlreadyClass);
            }

            body.classList.add(options.globalToggleClass);
        }

        if($(item).parents('#topbar').length && window.innerWidth >= 960) {
            body.classList.remove(options.globalToggleAlreadyClass);
            body.classList.remove(options.globalToggleClass);
        }

    });


    $(document).on('click', function(e){
        var container = $('#topbar__nav-top .menu-item');
        if (!container.is(e.target) && container.has(e.target).length === 0){
            container.removeClass('open');
        }
        else{
            //e.preventDefault();
        }
    });

};


const appendBack = (item) => {

    let sideNav = item.querySelector(`.${options.childrenClass}`);
    let close = item.querySelector(`.close`);


    if(sideNav) {

        let back = document.createElement("div");
        back.classList.add(options.backClass);
        back.textContent = options.backText;

        setEventClick(back, item);
        if(close) {
            setEventClick(close, item);
        }
        sideNav.insertBefore(back, sideNav.firstChild);

    }


};

const setMobileEvent = () => {

    const menuToggle = document.querySelector(options.mobileMenuSelector);
    const menuClose = document.querySelector(options.closeSelector);

    let body = document.querySelector('body');
    menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (body.classList.contains('mobile-menu-open')) {
            console.log('close');
            body.classList.remove('mobile-menu-open');
            menuToggle.classList.remove('is-active');
        } else  {
            console.log('open');
            body.classList.add('mobile-menu-open');
            menuToggle.classList.add('is-active');
        }
    });

    menuClose.addEventListener('click', (e) => {
        let subnav = document.querySelector('.menu-item.open');
        body.classList.remove('mobile-menu-open');
        body.classList.remove('menu-open');
        menuToggle.classList.remove('is-active');
        subnav.classList.remove('open');
    })
};


const init = () => {

    let container = document.querySelector(options.containerSelector);

    //wp default navigation
    let withChildrenItems = container.querySelectorAll('.menu-item-has-children');

    for(let i = 0; i < withChildrenItems.length; i++) {
        let link = withChildrenItems[i].querySelector('a');

        setEventClick(link, withChildrenItems[i]);

        if(!withChildrenItems[i].querySelector(`.${options.childrenClass}`)){

            let defaultWpChildren = withChildrenItems[i].querySelector('ul');
            if(defaultWpChildren) {
                defaultWpChildren.classList.add(options.childrenClass);
            }
        }

        appendBack(withChildrenItems[i]);

    }

    setMobileEvent();

    let overlay = document.querySelector('#overlay');
    overlay.addEventListener('click', (e) => {

        let withChildrenItems = container.querySelectorAll('.menu-item-has-children');
        for(let i = 0; i < withChildrenItems.length; i++) {
            if (withChildrenItems[i].classList.contains(options.toggleClass)) {
                withChildrenItems[i].classList.remove(options.toggleClass);
            }
        }

        let body = document.querySelector(`body`);
        body.classList.remove(options.globalToggleClass);
        body.classList.remove('mobile-menu-open');
        body.classList.remove(options.globalToggleAlreadyClass);


        const menuToggle = document.querySelectorAll(options.mobileMenuSelector);
        for(let i = 0; i < menuToggle.length; i++) {
            menuToggle[i].classList.remove('is-active');
        }

    });

    $(window).on('resize', function () {
        if($('body').hasClass('mobile-menu-open')){
            $(overlay).trigger('click');
        }
    })

};


export default {
    init
}
